import { Platform } from 'core/common/entities';

enum AnalyticsEventVariant {
  BASE = 'baseEvent',
  SKIP = 'skipEvent',
  CLICK = 'clickEvent',
  GET_OFFER = 'getOfferEvent',
}

export type AnalyticsEventProperties = Record<string, unknown>;

export type ExtendedAnalyticsEventValue = {
  name: string;
  properties: AnalyticsEventProperties;
};

export type AnalyticsEventValue = ExtendedAnalyticsEventValue | string;

export type AnalyticsEvent = Record<AnalyticsEventVariant, AnalyticsEventValue>;

export type FunnelProperties = {
  funnel: string;
  flow: string;
  language: string;
};

export type FunnelInfoProperties = {
  platform: Platform;
  country: string;
  language: string;
};

export type PaymentFormState = 'open' | 'click' | 'close' | 'close_method';

export type PaymentFormStateProperties = {
  state: PaymentFormState;
  payment_method?: string;
};

export type PaymentFormCompletedProperties = {
  state: 'success' | 'error';
} & AnalyticsEventProperties;

export const isExtendedAnalyticsEvent = (
  event: AnalyticsEventValue,
): event is ExtendedAnalyticsEventValue => {
  return typeof event !== 'string';
};
